module.exports = __webpack_public_path__ + "static/media/gy.333d94bf.svg";